<template>
  <div>
    <v-subheader>Efetuado em</v-subheader>
    <v-layout row wrap>
      <initial-date />
      <final-date />
    </v-layout>
  </div>
</template>
<script>
export default {
  name: 'DoneIn',
    components: {
    InitialDate: () => import('./InitialDate.vue'),
    FinalDate: () => import('./FinalDate.vue'),
  },
}
</script>
